<template>
  <b-container class="mt-2 mb-2">
    <b-row>
      <b-col cols="12">
        <div class="tableWrapper w-100">
          <b-row class="virtual-table-list-header" :class="{ hasScroll: sortedItems.length > 5 }">
            <b-col cols="3" @click="setSort('isin')" class="sortable" :class="sortClass('isin')">
              {{ $t('productDetails.kiid.isin') }}
            </b-col>
            <b-col cols="7" @click="setSort('name')" class="sortable" :class="sortClass('name')">
              {{ $t('productDetails.kiid.name') }}
            </b-col>
            <b-col cols="2" @click="setSort('srri')" class="sortable" :class="sortClass('srri')">
              {{ $t('productDetails.kiid.srri') }}
            </b-col>
          </b-row>
          <RecycleScroller class="scroller" :items="sortedItems" :item-size="45" key-field="id" v-slot="{ item }">
            <b-row class="virtual-table-list-row" :class="{ selected: item.id === selectedId }" @click="select(item)">
              <b-col cols="3">{{ item.isin }}</b-col>
              <b-col cols="7">{{ item.isin === item.name ? $t('common.notAvailable') : item.name }}</b-col>
              <b-col cols="2">{{ item.srri }}</b-col>
            </b-row>
          </RecycleScroller>
        </div>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import _ from 'lodash'

// The KIID row-list half of "Opzioni di investimento — lista"
// (InvestmentOptionsListSection.vue). The per-KIID detail data is not loaded upfront for the whole
// product; it needs a per-KIID call to the drilldown endpoint
// (GET /api/detail-page/investmentOption/{id}). So this component only renders the virtualized ROW
// LIST (RecycleScroller, own scoped CSS) — sortable by isin/name/srri; the
// detail panel itself is InvestmentOptionDetailPanel.vue, a sibling component shared with the SID
// table.
//
// In-page drilldown: a row click selects an option — `select`
// emits the clicked item, InvestmentOptionsListSection.vue forwards it to the shared
// selectInvestmentOption() on ProductDetails.vue (via the detailPage inject), same entry point
// the SID table drives. `item.id` is the Sid's own row id (InvestmentOptionKiidDto.Id) — the same
// id GET /api/detail-page/investmentOption/{id} expects, regardless of SidType.
export default {
  name: 'kiids-list-table',
  props: {
    items: { type: Array, required: true },
    selectedId: { type: Number, default: null },
  },
  data() {
    return {
      orderBy: '',
      orderAsc: true,
    }
  },
  computed: {
    sortedItems() {
      if (this.orderBy === '') {
        return this.items
      }
      const sorted = _.sortBy(this.items, [
        (item) => (typeof item[this.orderBy] === 'string' ? item[this.orderBy].toLowerCase() : item[this.orderBy]),
      ])
      return this.orderAsc ? sorted : _.reverse(sorted)
    },
  },
  methods: {
    setSort(column) {
      this.orderAsc = this.orderBy === column ? !this.orderAsc : true
      this.orderBy = column
    },
    sortClass(column) {
      return { asc: this.orderBy === column && this.orderAsc, desc: this.orderBy === column && !this.orderAsc }
    },
    select(item) {
      this.$emit('select', item)
    },
  },
}
</script>

<style lang="scss" scoped>
.virtual-table-list-header {
  padding: 5px 0px 5px 10px;
  margin: 0px;
  background-color: transparent !important;
  border-bottom: 2px solid #dee2e6;
  color: black !important;
  vertical-align: middle !important;
  font-weight: bold;
  align-items: center;
  &.hasScroll {
    padding-right: 27px;
  }
  .sortable {
    background-position: right 0.375rem center;
    background-repeat: no-repeat;
    background-size: 0.65em 1em;
    cursor: pointer;
    background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' preserveAspectRatio='none'%3E%3Cpath opacity='.3' d='M51 1l25 23 24 22H1l25-22zm0 100l25-23 24-22H1l25 22z'/%3E%3C/svg%3E");

    &.asc {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' preserveAspectRatio='none'%3E%3Cpath d='M51 1l25 23 24 22H1l25-22z'/%3E%3Cpath opacity='.3' d='M51 101l25-23 24-22H1l25 22z'/%3E%3C/svg%3E");
    }

    &.desc {
      background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' width='101' height='101' preserveAspectRatio='none'%3E%3Cpath opacity='.3' d='M51 1l25 23 24 22H1l25-22z'/%3E%3Cpath d='M51 101l25-23 24-22H1l25 22z'/%3E%3C/svg%3E");
    }
  }
}
.virtual-table-list-row {
  cursor: pointer;
  height: 45px;
  padding: 0 12px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #dee2e6;
  &.selected {
    font-weight: bold;
    background-color: #dcdcdc !important;
  }
  &:hover {
    background-color: rgba(0, 0, 0, 0.075);
  }
}
.tableWrapper {
  overflow: hidden;
  border: 1px var(--gray8) solid;
  border-radius: 0.5rem;
}
.scroller {
  max-height: 180px;
}
</style>
